import {MEASURE_UNIT_CHANGE} from "../constants/SiteDesigner";

export const changeMeasureUnit = (typeMeasureUnit) => ( {type: MEASURE_UNIT_CHANGE, typeMeasureUnit});
